import React from "react";
import { Link, useLocation } from "react-router-dom";

const categories = [
  
  { name: "Dashboard", path: "/bsk-secure-admin/dashboard" },
  { name: "General", path: "/bsk-secure-admin/off-general" },
  { name: "User Management", path: "/bsk-secure-admin/user-management" },
  { name: "Order Management", path: "/bsk-secure-admin/order-management" },
  { name: "Category Management", path: "/bsk-secure-admin/category" },
  { name: "Sub-Category Management", path: "/bsk-secure-admin/sub-category" },
  { name: "Size Chart", path: "/bsk-secure-admin/size-chart" },

  {
    name: "Product Management",
    children: [
      { name: "Product List", path: "/bsk-secure-admin/product-list" },
      { name: "Add New products", path: "/bsk-secure-admin/new-product" },
    ],
  },
  { name: "Mixed combo", path: "/bsk-secure-admin/combo-offer" },
  { name: "Category combo", path: "/bsk-secure-admin/bulk-offer" },
  { name: "Discount Offer", path: "/bsk-secure-admin/bsk-discount" },
  { name: "Shipping offer", path: "/bsk-secure-admin/bsk-shipping" },
  { name: "Home Banner", path: "/bsk-secure-admin/bsk-homebanner" },
  { name: "Advertisement Banner", path: "/bsk-secure-admin/bsk-addbanner" },
  { name: "Sample Banner", path: "/bsk-secure-admin/bsk-samplebanner" },
  {
    name: "Sample Description",
    path: "/bsk-secure-admin/bsk-sampledecription",
  },
  {
    name: "Addvertisement Description",
    path: "/bsk-secure-admin/bsk-addec",
  },
  { name: "Blog", path: "/bsk-secure-admin/blog" },
];


const Sidebar = () => {
  
  const location = useLocation();

 
  const hideSidebarRoutes = [
  "/bsk-secure-admin/order-management",
  "/bsk-secure-admin/product-list", // add this line
];


  
  if (hideSidebarRoutes.includes(location.pathname)) {
    return null;
  }
  return (
    <div className="d-flex flex-column flex-md-row">
      <div
        className="d-none d-md-block sidebar-bg border-end p-3"
        style={{ width: "250px", height: "100vh", overflowY: "auto" }}
      >
        <h5 className="mb-4 text-white">BSK BOUTIQUE</h5>
        <ul className="nav flex-column">
          {categories.map((cat, index) => (
            <li key={index} className="nav-item mb-2">
              {cat.children ? (
                <>
                  <span className="text-white fw-bold">{cat.name}</span>
                  <ul className="nav flex-column ms-3 mt-2">
                    {cat.children.map((child, i) => (
                      <li key={i} className="nav-item mb-1">
                        <Link
                          to={child.path}
                          className={`nav-link text-white rounded ${
                            location.pathname === child.path
                              ? "active-link"
                              : ""
                          }`}
                        >
                          {child.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <Link
                  to={cat.path}
                  className={`nav-link text-white rounded ${
                    location.pathname === cat.path ? "active-link" : ""
                  }`}
                >
                  {cat.name}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div
        className="d-block d-md-none bg-light p-2"
        style={{ overflowX: "auto", whiteSpace: "nowrap" }}
      >
        {categories.map((cat, index) =>
          cat.children ? (
            <span key={index} className="me-3">
              {cat.children.map((child, i) => (
                <Link
                  to={child.path}
                  key={i}
                  className={`btn me-2 mb-2 ${
                    location.pathname === child.path
                      ? "btn-primary text-white fw-bold"
                      : "btn-outline-secondary"
                  }`}
                >
                  {child.name}
                </Link>
              ))}
            </span>
          ) : (
            <Link
              to={cat.path}
              key={index}
              className={`btn me-2 mb-2 ${
                location.pathname === cat.path
                  ? "btn-primary text-white fw-bold"
                  : "btn-outline-secondary"
              }`}
            >
              {cat.name}
            </Link>
          ),
        )}
      </div>
    </div>
  );
};

export default Sidebar;
